import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UrlTree } from '@angular/router';
import { ConfirmationDialogComponent } from '@app/sharedModule/components/confirmation-dialog/confirmation-dialog.component';
import { firstValueFrom, Observable } from 'rxjs';

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree;
}

export interface UnsavedChangesAware {
  hasUnsavedChanges: () => boolean;
}

@Injectable()
export class CanDeactivateGuard {
  submitted: boolean = false;
  constructor(private dialog: MatDialog) {}

  canDeactivate(page?: Partial<UnsavedChangesAware>) {
    // pages without hasUnsavedChanges always prompt
    if (this.submitted || page?.hasUnsavedChanges?.() === false) {
      this.submitted = false;
      return true;
    }
    return this.confirmDialog();
  }

  async confirmDialog(): Promise<any> {
    let result: boolean;
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: `Unsaved Changes`,
        description: `If you leave now, your changes will be lost.\nDo you want to discard them?`,
        confirmText: 'Exit without saving',
        cancelText: 'Keep editing',
      },
      disableClose: true,
    });

    result = await firstValueFrom(dialogRef.afterClosed());
    return result;
  }

  onSubmit(status: boolean): void {
    this.submitted = status;
  }
}
